import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cIf from 'classnames';

var tr = require('ts-translate-js').default.boundTR;

//TODO: Change the prop showProfileEditionError to a more generic name, like showError
class UserFirstLastNames extends Component {

    constructor(props) {
        super(props);
    }
    
    handleOnFirstNameChange(e) {
        this.props.handleOnNamesChange({
            firstName: e.target.value, 
            lastName: this.props.lastName
        });
    }

    handleOnLastNameChange(e) {
        this.props.handleOnNamesChange({
            firstName: this.props.firstName, 
            lastName: e.target.value
        });
    }

    validateFirstNameFormat(firstName) {
        if (this.props.showProfileEditionError) {
            return (firstName != undefined && firstName.length > 0);
        }
        return true;
    }

    validateLastNameFormat(lastName) {
        if (this.props.showProfileEditionError) {
            return (lastName != undefined && lastName.length > 0);
        }
        return true;
    }

    createRequiredErrorMessage() {
        return (this.props.displayRequiredMessage) ? (
            <span id="helpBlock" className="help-block">{tr("Requis")}</span>
        ) : null;
    }

    render() {
        var firstNameErrorMessage = (this.validateFirstNameFormat(this.props.firstName)) ? null : this.createRequiredErrorMessage();
        var lastNameErrorMessage = (this.validateLastNameFormat(this.props.lastName)) ? null : this.createRequiredErrorMessage();
        return (
            <div>
                <div className={cIf({ "has-error": !this.validateFirstNameFormat(this.props.firstName), "form-group": true })}>
                    <label htmlFor="inputFirstName" className="control-label">{tr("profileinfo.firstname")}</label>
                    <input type="text" id="inputFirstName" autoFocus value={this.props.firstName} className="form-control" maxLength={50} onChange={(e) => this.handleOnFirstNameChange(e)}></input>
                    {firstNameErrorMessage}
                </div>
                <div className={cIf({ "has-error": !this.validateLastNameFormat(this.props.lastName), "form-group": true })}>
                    <label htmlFor="inputLastName" className="control-label">{tr("profileinfo.lastname")}</label>
                    <input type="text" id="inputLastName" value={this.props.lastName} className="form-control" maxLength={50} onChange={(e) => this.handleOnLastNameChange(e)}></input>
                    {lastNameErrorMessage}
                </div>
            </div>
        );
    }
}

UserFirstLastNames.propTypes = {
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    showProfileEditionError: PropTypes.bool,
    displayRequiredMessage: PropTypes.bool,
    handleOnNamesChange: PropTypes.func,
}

UserFirstLastNames.defaultProps = {
    displayRequiredMessage: true,
}

export default UserFirstLastNames;